import React from "react";
import Button from "../../Button";
import Overlay from "../../Overlay";
import excalamation from "../../../assets/img/icons/table/excalamation.svg";

function DndRestriction({ onCancel, open = true }) {
  const handleCloseDialog = () => {
    onCancel();
  };

  return (
    <Overlay show={open} closable={true} onClick={handleCloseDialog}>
      <div className="delete-confirm-wrapper">
        <div className="delete-confirm-container">
          <div className="are-you-sure">
            <img src={excalamation} alt={"excalamation"} />
            <p>Déplacement impossible</p>
          </div>

          <h1 className="popup-desc-content">
            La période sur laquelle vous souhaitez déplacer l'écriture est
            verrouillée.
            <br />
            <br />
            Ce déplacement est donc impossible et ne sera pas réalisé !
            <br />
            <br />
            Pour le réaliser, vous devez d'abord déverrouiller la période sur
            laquelle vous souhaitez « arriver ».
          </h1>

          <div className="delete-button-containers">
            <Button
              text={"Ok, j'ai compris"}
              onClick={handleCloseDialog}
              className={"action-button agree-action-button"}
            />
          </div>
        </div>
      </div>
    </Overlay>
  );
}

export default DndRestriction;
